import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54313fa9&"
import script from "./zPayTxtFieldPaymentAmount.js?vue&type=script&lang=js&"
export * from "./zPayTxtFieldPaymentAmount.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports